import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade } from 'swiper/modules';

import {$qs, $qsa} from '../../../src/js/utils/querySelector';


function blockquote() {
    const blockquoteSwipers = document.querySelectorAll('[data-name="blockquote-swiper"]');

    if (blockquoteSwipers.length > 0) {
        // Starting point
        blockquoteSwipers.forEach((blockquoteSwiper) => {

            function initializeSwiper() {

                let swiper = new Swiper(blockquoteSwiper, {
                    modules: [ Navigation, Pagination, EffectFade ],
                    effect: "fade",
                    fadeEffect: { crossFade: true },
                    slidesPerView: 1,
                    spaceBetween: 0,
                    speed: 1000,
                    pagination: {
                        el: $qs(".swiper-pagination", blockquoteSwiper),
                        clickable: true,
                      },
                    // breakpoints: {
                    //     // md
                    //     728: {
                    //         slidesPerView: 2.1,
                    //         // slidesPerView: 'auto',
                    //         spaceBetween: 50,
                    //     },
                    //     // xl
                    //     1440: {
                    //         slidesPerView: 2,
                    //         // slidesPerView: 'auto',
                    //         spaceBetween: 50,
                    //     },
                    // },
                });

                

            }

            // Initialize Swiper when the function is called
            initializeSwiper();



            // Also re-initialize when the window is resized
            window.addEventListener('resize', initializeSwiper);
        });
    }
}

export default blockquote;